<div [@routerTransition] class="m-0 p-0">
      <section *ngIf="equipeId" class="m-0">
        <div>
          <div class="row">
            <div class="contatos col-sm-3 col-12 col-lg-2 p-0 m-0">
              <ng-container *ngFor="let conversa of conversas; trackBy: trackByEquipeId">
                <chat-card [user]="conversa" [userIdSelecionado]="equipeId" [temNotificacoes]="temNotificacao(conversa.lastRemetenteId, conversa.equipeId)" [isNew]="isNew(conversa.equipeId)" (click)="obterMensagens(conversa.equipeId, conversa.lastRemetenteId)"></chat-card> 
              </ng-container>
            </div>
            <div class="chat h-80 col-sm-9 col-12 col-lg-10 p-0 m-0">
              <chat-messages class="h-80" *ngIf="equipeId" [eventRolarMensagens]="eventRolarMensagensSubject.asObservable()" [equipe]="getConversa()" [equipeId]="equipeId"  [destinatarioId]="destinatarioId" [chatMensagens]="chatMensagens"></chat-messages>
            </div>
          </div>
        </div>
      </section>

      <div class="d-flex align-items-center justify-content-center" *ngIf="!equipeId">
        <p class="h1 text-center my-auto p-5">Sem conversas disponíveis</p>
      </div>
</div>
